import { historySVC } from "app/history/service"
import { FORM_TABS } from "form/model"
import { CAMPAIGN_TAB_ID_QUERY_PARAM } from "page/model"

export function getTabIdInUrl(): FORM_TABS | undefined {
  historySVC.transformSearchParamsIntoHashParams(CAMPAIGN_TAB_ID_QUERY_PARAM)
  const tab = historySVC.getHashParameter(CAMPAIGN_TAB_ID_QUERY_PARAM)
  if (tab !== "") {
    return tab as FORM_TABS
  }
  return undefined
}
